import { PayloadAction } from '@reduxjs/toolkit';
import { FormatState } from 'src/store/format/types';

const setAllFormatsAreLoadingReducer = (state: FormatState, action: PayloadAction<boolean>) => {
  state.allFormatsAreLoading = action.payload;
};

export default setAllFormatsAreLoadingReducer;
